import { useEffect, useMemo, useState } from "react";

import { IS_STAGING } from "@/config/environment";

export function useAppStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  const showBanner = useMemo(() => !isOnline || IS_STAGING, [isOnline]);

  return {
    isOnline,
    isStaging: IS_STAGING,
    showBanner,
  };
}
